<template lang="pug">
  .box-join.col-md-2.col-sm-2.col-xs-6
    .board
      .board-img
        img(:src="item.thumbnail" v-if="item.thumbnail !== undefined  && item.thumbnail !== null && item.thumbnail.length > 0")
        img(src="../../../assets/images/faces/ic_AvatarDefault@2x.png" v-else)
      .board-info
        .title-classes 
          span {{item.name}}
        div(v-if="!$store.getters.isLoggedIn || ($store.getters.fullname !== undefined && $store.getters.fullname !== null && $store.getters.fullname.type_user !== 2)")
          button.btn-join.ticket(@click="onClassOfUser(item)" v-if="$store.getters !== null && $store.getters.isLoggedIn && status === 2")
            img(src="../../../assets/images/faces/ic_check@2x.png")
            span {{this.$t('landing.joined')}}
          button.btn-join(v-else-if="$store.getters !== null  && $store.getters.isLoggedIn && status === 1") {{this.$t('landing.send_requested')}}
          button.btn-join.active(@click="joinNow(item)" v-else) {{this.$t('landing.join_now')}}
</template>
<script>
import gql from 'graphql-tag'
import graphql from '../../Model/graphqlfront'
import LoginModal from '@/components/Account/LoginModal'
export default {
  props: {
    item: Object,
    pcID: Number
  },
  data() {
    return {
      status: 0,
      deleted: false
    }
  },
  async mounted () {
    this.status = 0
    if (this.$store.getters.isLoggedIn) {
      var objWhere = {
        user_id: {_eq: this.$store.getters.user},
        pc_id: {_eq: this.pcID},
        classes_id: {_eq: this.item.id}
      }
      const {data} = await this.$apollo.query({
        query: gql(graphql.GET_JOIN_PC_USER_CLASSES),
        fetchPolicy: 'no-cache',
        variables: {
          objWhere: objWhere
        }
      })
      if (data && data !== null && data.pc_user !== null && data.pc_user.length > 0) {
        var pcUser = data.pc_user[0]
        // giữ xem tài khoản có deleted không
        this.deleted = pcUser.is_delete
        // nếu tồn tại dòng pc user và chưa deleted
        if (pcUser && pcUser !== null && !pcUser.is_delete) this.status = Number(data.pc_user[0].status)
      }
      // nếu có action gửi yêu cầu thì send
      if (this.$route.query.join !== undefined && Number(this.$route.query.join) > 0 && this.status === 0) {
        if (Number(this.$route.query.join) === this.item.id) this.joinNow(this.item)
      }
    }
  },
  methods: {
    getLinkCurrent(item) {
      this.$store.commit('setIsHomePage', true)
      var path = this.$route.path
      if (path.length > 0 && path[0] === '/') path = this.$mycontroller.removeByIndexFromString(path, 1)
      var link = window.location.origin + '/' + this.$router.resolve({path: '/'}).href
      return link + path + '?join=' + item.id
    },
    async joinNow(item) {
      if (!this.$store.getters.isLoggedIn) {
        this.$store.commit('setIsHomePage', true)
        let scrollTop = this.$mycontroller.getScrollTop(window)
        var params = this.$route.params
        params = Object.assign(params, {name: this.$route.name})
        params = Object.assign(params, {front_top: scrollTop})
        params = Object.assign(params, {object_id: item.id})
        params = Object.assign(params, {joinNow: true})
        params = Object.assign(params, {url: this.getLinkCurrent(item)})
        try {
          this.$modal.show(LoginModal, {params: params}, {
            // width: '43%',
            height: 'auto',
            classes: ['col-6'],
            adaptive: true,
            resize: true,
            clickToClose: false
          })
        } catch (e) {}
      } else {
        if (this.pcID > 0 && this.item.id > 0 && this.$store.getters.fullname !== undefined && this.$store.getters.fullname !== null && this.$store.getters.fullname.type_user === 1) {
          var approval = await this.getTypeApproval(this.item.id)
          this.status = Number(approval) === 1 ? 1 : 2
          // cập nhật pc user
          if (this.deleted) {
            var $objWhere = {
              pc_id: {_eq: this.pcID},
              classes_id: {_eq: this.item.id},
              user_id: {_eq: this.$store.getters.user}
            }
            var $objInput = {
              status: this.status,
              is_delete: false
            }
            await this.$apollo.mutate({
              mutation: gql(graphql.UPDATE_PC_USER),
              variables: {
                objWhere: $objWhere,
                objInput: $objInput
              },
              update: (store, { data: { update_pc_user } }) => {
                console.log('update')
              }
            }).catch((error) => {
              console.log('error', error)
              if (error.graphQLErrors[0].extensions.code === 'invalid-jwt') {
                this.$router.go(0, this.$route.params, this.$route.query)
              }
            })
          } else {
            var $objects = {
              pc_id: this.pcID,
              classes_id: this.item.id,
              user_id: this.$store.getters.user,
              status: this.status,
              is_delete: false
            }
            await this.$apollo.mutate({
              mutation: gql(graphql.SEND_REQUEST_USER_JOIN_PC),
              variables: {
                objects: $objects
              },
              update: (store, { data: { insert_pc_user } }) => {
                console.log('created')
              }
            }).catch((error) => {
              console.log('error', error)
              if (error.graphQLErrors[0].extensions.code === 'invalid-jwt') {
                this.$router.go(0, this.$route.params, this.$route.query)
              }
            })
          }
        }
      }
    },
    async getTypeApproval(classID) {
      // duyet thu cong
      var approval = 1
      var objWhere = {
        id: {_eq: classID}
      }
      const {data} = await this.$apollo.query({
        query: gql(graphql.GET_CLASSES),
        fetchPolicy: 'no-cache',
        variables: {
          where: objWhere
        }
      })
      if (data && data !== null && data.classes !== null && data.classes.length > 0) {
        approval = Number(data.classes[0].type_approval)
      }
      return approval
    },
    onClassOfUser(item) {
      this.$store.commit('setIsHomePage', false)
      this.$router.push({name: 'classes_to_me_detail', query: {id: this.item.id}, params: {reload: 1}})
    }
  }
}
</script>
<style lang="scss">
 .front-landing-page{
    .content{
      &.front{
        .box-join{
          .board{padding: 15px; background: #FFFFFF 0% 0% no-repeat padding-box; box-shadow: 0px 1px 2px #00000029;border-radius: 10px; margin-bottom: 16px;
            .board-img{width: 64px; height: 64px; margin: 0 auto; overflow: hidden; border-radius: 50%; display: flex;
              img{max-width: 100%; height: auto; object-fit: cover;}
            }
            .board-info{ margin-top: 16px;
              .title-classes{color: #343A40; font-size: 15px; min-height: 40px; display: table; width: 100%; text-align: center; 
                span{display: table-cell; vertical-align: middle;}
              }
              .btn-join{margin-top: 16px; color: #343A40; font-size: 14px;background: #FFFFFF 0% 0% no-repeat padding-box;border: 1px solid #FFD311;border-radius: 5px; width: 100%; min-height: 32px;
                &.ticket{background: transparent;
                  img{width: 24px; height: 24px;}
                  span{display: inline-block;}
                }
                &.active{ background: #FFD311;}
              }
            }
          }
        }
      }
    }
 }
@media (max-width: 1024px){
  .front-landing-page{
    .content{
      &.front{
        .custom-classes{
          .box-join{width: 20%;}
        }
      }
    }
  }
}
@media (max-width: 991px){
  .front-landing-page{
    .content{
      &.front{
        .custom-classes{
          .box-join{width: 33.33%;}
        }
      }
    }
  }
}
@media (max-width: 768px){
  .front-landing-page{
    .content{
      &.front{
        .custom-classes{
          .box-join{width: 33.33%;}
        }
      }
    }
  }
}
@media (max-width: 639px){
  .front-landing-page{
    .content{
      &.front{
        .custom-classes{
          .box-join{width: 50%;}
        }
      }
    }
  }
}
@media (max-width: 375px) {
  .front-landing-page{
    .content{
      &.front{
        .box-join{
          .board{
            .board-info{
              .btn-join{font-size: 13px;
                img{width: 18px !important;}
              }
            }
          }
        }
      }
    }
  }
}
@media (max-width: 320px) {
  .front-landing-page{
    .content{
      &.front{
        .box-join{
          .board{
            .board-info{
              .btn-join{font-size: 10px;
                img{width: 18px !important;}
              }
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// itemClasses.vue?2826aef2